__turbopack_context__.v({
  "className": "dm_mono_a085209c-module__8922JW__className",
  "variable": "dm_mono_a085209c-module__8922JW__variable",
});
